import { render, staticRenderFns } from "./InfoVerification.vue?vue&type=template&id=461cacdf&scoped=true&"
import script from "./InfoVerification.vue?vue&type=script&lang=js&"
export * from "./InfoVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461cacdf",
  null
  
)

export default component.exports